export function initSlider($) {
    $(".slider.slider-standard").each(function (n, el) {
        let delay = parseInt($(el).data("delay"));

        if (isNaN(delay)) {
            delay = 8000;
        }

        var stagePadding = 0;

        if ($(el).hasClass('alignwide') || $(el).hasClass('alignfull')) {
            stagePadding = 250;
        }

        $(".owl-carousel", el).owlCarousel({
            items: 1,
            loop: true,
            nav: true,
            dots: true,
            autoplay: false,//delay > 0,
            autoplayTimeout: delay,
            autoplayHoverPause: true,
            smartSpeed: 1100,

            responsive: {
                0: {
                    margin: 0,
                    stagePadding: 0,
                },
                // breakpoint from X-LARGE up
                1200: {
                    margin: 20,
                    stagePadding: stagePadding,
                }
            }
        });
    });

    $(".slider.slider-block").each(function (n, el) {
        let $slider = $(".owl-carousel", el);
        let delay = parseInt($(el).data("delay"));
        let random = $(el).data("random");

        if (isNaN(delay)) {
            delay = 8000;
        }

        // randomise the slide order
        if (random) {
            for (var i = $slider[0].children.length; i >= 0; i--) {
                $slider[0].appendChild($slider[0].children[(Math.random() * i) | 0]);
            }
        }

        $slider.owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: true,
            autoplay: delay > 0,
            autoplayTimeout: delay,
            smartSpeed: 1000,

            animateIn: "fadeIn",
            animateOut: "fadeOut",
        });
    });

    $(".slider.slider-block-arrows").each(function (n, el) {
        let $slider = $(".owl-carousel", el);
        let delay = parseInt($(el).data("delay"));
        let random = $(el).data("random");

        if (isNaN(delay)) {
            delay = 8000;
        }

        // randomise the slide order
        if (random) {
            for (var i = $slider[0].children.length; i >= 0; i--) {
                $slider[0].appendChild($slider[0].children[(Math.random() * i) | 0]);
            }
        }

        $slider.owlCarousel({
            items: 1,
            loop: true,
            nav: true,
            dots: true,
            autoplay: delay > 0,
            autoplayTimeout: delay,
            smartSpeed: 1000,

            animateIn: "fadeIn",
            animateOut: "fadeOut",
        });
    });


    $(".slider.slider-block-nav").each(function (n, el) {
        let slider = $(".owl-carousel", el);
        let delay = parseInt($(el).data("delay"));
        let random = $(el).data("random");

        if (isNaN(delay)) {
            delay = 8000;
        }

        // randomise the slide order
        if (random) {
            for (var i = $slider[0].children.length; i >= 0; i--) {
                slider[0].appendChild($slider[0].children[(Math.random() * i) | 0]);
            }
        }

        let s = slider.owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: true,
            autoplay: delay > 0,
            autoplayTimeout: delay,
            smartSpeed: 1000,

            // animateIn: "slideIn",
            // animateOut: "slideOut",
        });

        s.on('changed.owl.carousel', function (a) {
            updateActive(a);
        });

        var $navigation = $('#block-slider-nav-navigation');
        $(".block-slider-nav .owl-item").not('.cloned').each(function (index) {
            var $headings = $(this).find("h3");
            $headings.each(i => {
                var heading = $headings[i];
                var li = document.createElement("li");
                li.setAttribute('data-id', index);
                li.className = "block-slider-nav-navigation-item " + (index == 0 ? 'active' : '');
                $("<a/>", {
                    html: heading.innerText,
                    click: function () {
                        s.trigger('to.owl.carousel', [index, 0]);
                    }
                }).appendTo(li);
                $navigation.append(li);
            });
        });
    });

    function updateActive(a) {
        var $headings = $('#block-slider-nav-navigation').find(".block-slider-nav-navigation-item");
        $headings.each(i => {
            var heading = $headings[i];
            heading.classList.remove("active");

            if (heading.getAttribute('data-id') == a.page.index) {
                heading.classList.add("active");
            }
        });
    }
}
